export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-Ver-1-16.d6b5a5be.png";